module.exports = {
	name: {
		dependentFields: ['firstName', 'lastName'],
		formulate: ({ firstName, lastName }) => {
			return `${firstName} ${lastName}`;
		}
	}
};
